import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import DOMPurify from "dompurify";
import { initNewRelic } from "./App.newrelic";

import messagesDE from "./translations/de.json";
import messagesEN from "./translations/en.json";
import messagesES from "./translations/es.json";
import messagesFR from "./translations/fr.json";

export function GetVar(variable) {
  const searchParams = new URLSearchParams(window.location.search);
  const value = searchParams.get(variable);
  const output = value === null ? "" : value;
  return DOMPurify.sanitize(output);
}

const messages = {
  en: messagesEN,
  es: messagesES,
  de: messagesDE,
  fr: messagesFR,
};

let language =
  GetVar("locale") !== "" ? GetVar("locale").split(/[-_]/)[0] : "en";
language = Object.keys(messages).includes(language) ? language : "en";
let locale = GetVar("locale") !== "" ? GetVar("locale") : "en";
locale = Object.keys(messages).includes(language) ? locale : "en";

initNewRelic();

ReactDOM.render(
  <IntlProvider locale={locale} messages={messages[language]}>
    <BrowserRouter>
      <App language={language} locale={locale} className="App" />
    </BrowserRouter>
  </IntlProvider>,
  document.getElementById("root")
);
